import http from "../axios/http-common";

class InterfacePasien {
  getDetailPemeriksaan(idReg) {
    return http.getData(`/register/${idReg}/pemeriksaan-ralan`);
    // return http.getData(`/register/pemeriksaan-ralan/${idReg}`);
  }

  updateAlergi(rm, alergi) {
    return http.putData(`/pasien/${rm}/alergi`, {
      alergi: alergi
    });
  }

  getDetailKonsulan(idKonsul) {
    return http.getData(`/surat-konsul/${idKonsul}`);
  }
 // data sosial pemeriksaan
  getPasien(rm) {
    return http.getData(`/pasien/${rm}`);
  }
  getPasienLastReg(rm) {
    return http.getData(`/pasien-last-reg/${rm}`);
  }

  getPasienByParam(term) {
    return http.getDataParam(`/pasien`, {
      term: term
    });
  }
  // getKunjunganPasien(rm) {
  //   return http.getData(`/pasien/${rm}/riwayat-kunjungan`);
  // }
}

export default new InterfacePasien();
